import BaseModal from "./utils/BaseModal";
import Table from "./utils/Table";
import React from "react";
import SafeHtml from "../components/SafeHtml";

export default function SectionRowHistoryModal({ assessmentID, entryID }) {
  const columnDef = [
    {
      id: "id",
      name: "ID",
      selector: (row) => row.id,
      omit: true,
    },
    {
      id: "date",
      name: "Date",
      selector: (row) => row.date,
      width: "10%",
      wrap: true,
    },
    {
      id: "change_summary",
      name: "Modification",
      selector: (row) => row.change_summary,
      wrap: true,
      width: "12%",
    },
    {
      id: "old_value",
      name: "Ancienne valeur",
      selector: (row) => row.old_value,
      wrap: true,
      format: (row) =>
        row.old_value != null &&
        row.old_value !== "" &&
        row.old_value !== "-" ? (
          <SafeHtml html={row.old_value} />
        ) : (
          "—"
        ),
      width: "15%",
    },
    {
      id: "new_value",
      name: "Nouvelle valeur",
      selector: (row) => row.new_value,
      wrap: true,
      format: (row) =>
        row.new_value != null &&
        row.new_value !== "" &&
        row.new_value !== "-" ? (
          <SafeHtml html={row.new_value} />
        ) : (
          "—"
        ),
      width: "15%",
    },
    {
      id: "content",
      name: "Détail",
      selector: (row) => row.content,
      wrap: true,
      format: (row) => (row.content ? <SafeHtml html={row.content} /> : "—"),
      width: "18%",
    },
    {
      id: "justification_note",
      name: "Note justificative",
      selector: (row) => row.justification_note,
      wrap: true,
      format: (row) =>
        row.justification_note ? (
          <span className="fst-italic text-muted">
            {row.justification_note}
          </span>
        ) : (
          "—"
        ),
      width: "20%",
    },
    {
      id: "modified_by",
      name: "Modifié par",
      selector: (row) => row.modified_by,
      wrap: true,
      width: "15%",
    },
  ];

  let modalTitle = "Historique pour la phrase #" + entryID;
  let fetchDataPath =
    "/pcrs-assessment-edit/" + assessmentID + "/history/" + entryID;

  return (
    <BaseModal modalTitle={modalTitle}>
      <Table
        columnDef={columnDef}
        selectableRows={false}
        fetchDataPath={fetchDataPath}
      />
    </BaseModal>
  );
}
